import classNames from 'classnames'
import { useRouter } from 'next/router'
import styles from './Encyclopedia.module.scss'
import CategoryCard from 'components/encyclopedia/category-card/CategoryCard'
import { EncyclopediaProps } from './types'
import ArticleSection from 'components/article/article-section/ArticleSection'
import EncyclopediaSearchBar from 'components/encyclopedia/search-bar/EncyclopediaSearchBar'
import { Header, Heading } from '@boltenergy-be/design-system'
import { Language } from 'types/language'

const Encyclopedia = ({ categories, popularArticles, content }: EncyclopediaProps) => {
  // ROUTER
  const { locale: language } = useRouter()

  // Constants
  const { description, popularTitle, searchPlaceholder, searchTitle, title } = content

  return (
    <main>
      {/* INTRO */}
      <Header docked color="accent-soft" title={title} classnames={{ container: styles.header }}>
        <p>{description}</p>
        <Heading as="h2" variant="h4" className="mt-700">
          {searchTitle}
        </Heading>
        <EncyclopediaSearchBar placeholder={searchPlaceholder} className={styles.search} />
      </Header>

      {/* CATEGORIES */}
      <nav className={classNames('container', styles.categories)}>
        {!!categories?.length && categories.map((cat) => <CategoryCard key={cat.id} category={cat} language={language as Language} />)}
      </nav>

      {/* POPULAR */}
      <ArticleSection articles={popularArticles} title={popularTitle} className={styles.popular} />
    </main>
  )
}

export default Encyclopedia
